export default [
  {
  "id": 18,
  "name": "工程浏览",
  "suffix": "gtj,gtjjy,gtjxs",
  "icon": "achakanmoxing",
  "gray": null,
  "userType": 3,
  "openType": 1,
  "windowName": "target_gtj",
  "linkUrl": "/model-browsing/#/browsing/filename/${name}/path/${path}/spaceType/${spaceType}/projectIOType/${projectIOType}/fileId/${fileId}/workspaceId/${workspaceId}",
  "linkParameter": "",
  "menuId": 64
  },
  {
  "id": 24,
  "name": "预览",
  "suffix": "gbq5,gbq6,gbq6jy,gbq6xs,gbq7",
  "icon": "yulan-xiazai r2-icon-action_find_in_page_outlined",
  "gray": null,
  "userType": 3,
  "openType": 1,
  "windowName": "target_gbq5",
  "linkUrl": "/#/preview/${fileSuffix}",
  "linkParameter": "fileType,path,workspaceId,fileName",
  "menuId": 64
  },
  {
  "id": 27,
  "name": "工程浏览",
  "suffix": "gdq",
  "icon": "achakanmoxing",
  "gray": null,
  "userType": 3,
  "openType": 1,
  "windowName": "target_gdq",
  "linkUrl": "/deco-browsing/#/deco-cloud/viewId/${viewId}/viewToken/${viewToken}/spaceId/${workspaceId}/projectId/${projectId}/fileId/${fileId}/spaceType/${spaceType}/homeHref/${homeHref}/filename/${name}",
  "linkParameter": "",
  "menuId": 64
  },
  {
  "id": 32,
  "name": "工程浏览",
  "suffix": "gqi4,gqijy,gqixs",
  "icon": "achakanmoxing",
  "gray": null,
  "userType": 3,
  "openType": 1,
  "windowName": "target_gqi4",
  "linkUrl": "/gqi-browsing/#/gqi-browsing/viewId/${viewId}/viewToken/${viewToken}/filename/${name}/path/${path}/spaceType/${spaceType}",
  "linkParameter": "",
  "menuId": 64
  },
  {
  "id": 38,
  "name": "图片浏览",
  "suffix": "png,jpeg,bmp,jpg,gif",
  "icon": "yulan-xiazai r2-icon-action_find_in_page_outlined",
  "gray": null,
  "userType": 3,
  "openType": 2,
  "windowName": "",
  "linkUrl": "",
  "linkParameter": "",
  "menuId": 64
  },
  {
  "id": 42,
  "name": "预览",
  "suffix": "docx,doc,xlsx,xls,pdf",
  "icon": "yulan-xiazai r2-icon-action_find_in_page_outlined",
  "gray": null,
  "userType": 3,
  "openType": 1,
  "windowName": "target_doc",
  "linkUrl": "/#/preview/${fileSuffix}",
  "linkParameter": "CBDToken,previewUrl,fileName,name",
  "menuId": 64
  },
  {
  "id": 53,
  "name": "预览",
  "suffix": "mp4",
  "icon": "yulan-xiazai r2-icon-action_find_in_page_outlined",
  "gray": null,
  "userType": 3,
  "openType": 1,
  "windowName": "target_mp4",
  "linkUrl": "/deco-browsing/#/video/viewId/${viewId}/spaceId/${spaceId}/filename/${name}",
  "linkParameter": "",
  "menuId": 64
  },
  {
  "id": 59,
  "name": "dwg预览",
  "suffix": "dwg",
  "icon": "yulan-xiazai r2-icon-action_find_in_page_outlined",
  "gray": null,
  "userType": 3,
  "openType": 1,
  "windowName": "target_dwg",
  "linkUrl": "/deco-browsing/#/dwg/viewId/${viewId}/viewToken/${viewToken}/filename/${name}",
  "linkParameter": "",
  "menuId": 64
  },
  {
  "id": 63,
  "name": "pano编辑",
  "suffix": "pano",
  "icon": "bianji",
  "gray": null,
  "userType": 3,
  "openType": 1,
  "windowName": "target_pano",
  "linkUrl": "/deco-browsing/#/vr_edit/viewId/${viewId}/spaceId/${spaceId}/userType/${userType}/homeHref/${homeHref}/filename/${name}",
  "linkParameter": "",
  "menuId": 64
  },
  {
  "id": 69,
  "name": "预览",
  "suffix": "gsc5,gpv5,gsh5,gpb5,gsc6,gpv6,gsh6,gpb6,gsc6jy,gpv6jy,gsh6jy,gpb6jy,gsc6xs,gpv6xs,gsh6xs,gpb6xs,gsc7,gpv7,gsh7,gpb7",
  "icon": "yulan-xiazai r2-icon-action_find_in_page_outlined",
  "gray": null,
  "userType": 3,
  "openType": 1,
  "windowName": "target_gsc5",
  "linkUrl": "/#/preview/${fileSuffix}",
  "linkParameter": "path,workspaceId,fileName,fileType",
  "menuId": 64
  },
  {
  "id": 88,
  "name": "预览",
  "suffix": "SKP,OBJ,FBX,DXF,DWF,DAE,STL,RVT,3DS,RFA,IGMS,E5D,GMP,CADI2,NWC,NWD,RTE,IFC,3DM,DGN,STP,STEP,RVM,OSGB,PLY,GCL10,GGJ12",
  "icon": "achakanmoxing",
  "gray": null,
  "userType": 3,
  "openType": 1,
  "windowName": "",
  "linkUrl": "/#/preview/${fileSuffix}",
  "linkParameter": "viewId,viewToken,spaceType,fileName",
  "menuId": 64
  }
]
